var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-keep-alive",
    {
      staticClass: "flex flex-col",
      style: _vm.virtualViewportStyle,
      attrs: { "data-component": "base-virtual-scroll-viewport" },
    },
    [
      _vm.isHeaderVisible && _vm.$slots["footer"]
        ? _c(
            "base-resize-observer",
            {
              key: _vm.HEADER_SLOT_KEY,
              on: {
                resize: function ($event) {
                  return _vm.$emit("header-slot-resize", $event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "base-virtual-scroll-viewport-item" },
                [_vm._t("header")],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.visibleItems, function (item, vIndex) {
        return _c("base-virtual-scroll-viewport-item", {
          key: _vm.getItemId(item),
          attrs: {
            "item-id": _vm.getItemId(item),
            "item-size": _vm.getItemSize(item),
            "real-index": _vm.getRealIndex(vIndex),
            "render-delay": _vm.renderDelay,
          },
          on: {
            activation: function ($event) {
              return _vm.onItemActivation(item)
            },
            deactivation: function ($event) {
              return _vm.onItemDeactivation(item)
            },
            resize: function ($event) {
              return _vm.onItemResize(item, $event)
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function () {
                  return [
                    _vm._t("default", null, {
                      index: _vm.getRealIndex(vIndex),
                      data: item,
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "placeholder",
                fn: function () {
                  return [_vm._t("placeholder")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        })
      }),
      _vm._v(" "),
      _vm.isFooterVisible && _vm.$slots["footer"]
        ? _c(
            "base-resize-observer",
            {
              key: _vm.FOOTER_SLOT_KEY,
              on: {
                resize: function ($event) {
                  return _vm.$emit("footer-slot-resize", $event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "base-virtual-scroll-viewport-item" },
                [_vm._t("footer")],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading ? _vm._t("loader") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }